import React, { createContext, useState, useEffect, useMemo } from "react";
import { computeExamCounts } from "@learnzapp/core/welcome";

//API
import { getExamStats } from "../api/content";
import { GET_APP_DOMAIN_LIST, GET_PRACTICE_TEST } from "../../app_constant";

export const ContentContext = createContext();

export const ContentProvider = (props) => {
  const [examStats, setExamStats] = useState([]);

  useEffect(() => {
    // Get exam statistics on mount
    const stats = getExamStats();
    setExamStats(stats);
  }, []);

  // Helper function to get content counts for a specific certification
  const getContentCounts = (certKey) => {
    const cert = examStats.find(stat => stat.key === certKey);
    return cert || { questions: 0, flashcards: 0, articles: 0 };
  };

  // Per-exam free/total/premium split (web twin of the mobile ContentProvider
  // counts). The math lives in @learnzapp/core/welcome so both apps promise
  // free users the exact same numbers. Totals come from examStats, which uses
  // BUNDLE_ARTICLE_COUNTS for articles — article bodies load lazily on web,
  // so counts stay synchronous.
  const counts = useMemo(() => {
    const byExam = {};
    for (const stat of examStats) {
      byExam[stat.key] = computeExamCounts({
        domainList: GET_APP_DOMAIN_LIST(stat.key),
        totals: stat,
        practiceTests: GET_PRACTICE_TEST(stat.key),
      });
    }
    return byExam;
  }, [examStats]);

  const getCountsForExam = (certKey) => counts[certKey] || computeExamCounts();

  // Calculate totals across all certifications
  const totals = useMemo(() => {
    return examStats.reduce(
      (acc, stat) => ({
        questions: acc.questions + stat.questions,
        flashcards: acc.flashcards + stat.flashcards,
        articles: acc.articles + stat.articles,
        practiceTests: acc.practiceTests + stat.practiceTests,
        glossary: acc.glossary + stat.glossary,
      }),
      { questions: 0, flashcards: 0, articles: 0, practiceTests: 0, glossary: 0 }
    );
  }, [examStats]);

  return (
    <ContentContext.Provider
      value={{
        examStats,
        getContentCounts,
        getCountsForExam,
        totals,
      }}
    >
      {props.children}
    </ContentContext.Provider>
  );
};
